import React, { useState } from 'react';

import ActionLink from '../../builder/ActionLink';
import CookiesAdvise from '../layers/CookiesAdvise';
import { isNotEmpty } from '../../../lib/ep';

const CookiesButton = (props) => {
	const promotion = props?.promotion ?? false;
	if(promotion === false) return null;

	const [ display_layer, setDisplayLayer ] = useState(false);

	const is_builder = props?.is_builder ?? false;
	
	const label = props?.children ?? "Cookie policy";

	const icon = props?.icon ?? 'knk-cookie';

	const external_cookies_url = (isNotEmpty(promotion, 'external_cookies_url')) ? promotion.external_cookies_url : false;

	const open = () => {
		if (is_builder) return;
		setDisplayLayer(true);
	}

	return (
		<>
			<ActionLink
				icon={(icon !== false) ? icon : null}
				_target="_blank"
				_href={external_cookies_url != false ? external_cookies_url: null}
				onClick={external_cookies_url == false ? open :null}
				_class={{ other:'cookies_btn' }}
			>{label}</ActionLink>

			{(display_layer) && (
				<CookiesAdvise
					pm={promotion}
					from_action={true}
					force_view={'legal_text'}
					force_close={() => setDisplayLayer(false)}
				/>
			)}
		</>
	)
};

export default CookiesButton;